import { createVNode, render } from 'vue-demi'
import XtxConfirm from './xtx-confirm.vue'

// 准备一个DOM
const div = document.createElement('div')
div.setAttribute('class', 'xtx-confirm-container')
document.body.appendChild(div)

// 返回的是promise對象，点取消销毁組件，点確認销毁組件
export default ({ title, text }) => {
  // 1. 导入被创建的組件
  // 2. 使用createVNode创建虚拟节点
  // 3. 准备一个dom容器装载組件
  // 4. 使用render函數渲染組件到容器
  return new Promise((resolve, reject) => {
    // 点击取消触发的函數
    const cancelCallback = () => {
      render(null, div)
      reject(new Error('点击取消'))
    }
    // 点击確認触发的函數
    const submitCallback = () => {
      render(null, div)
      resolve()
    }

    const vn = createVNode(XtxConfirm, { title, text, cancelCallback, submitCallback })
    render(vn, div)
  })
}
